<div>
    <div class="row mb-1" *ngIf="skillsData?.length > 0">
        <div class="col">
            <p class="f-14 font-weight-600 mb-3 d-flex justify-content-between">
                <span> <i class="fa-regular fa-book-open f-12 font-weight-normal mr-2"></i>Skills</span>
            </p>
            <div class=" d-flex align-items-baseline" *ngIf="skillsData?.length > 0">
                <div class="w-100">
                    <div class="d-flex f-12 flex-wrap mb-2">
                        <span class="f-14 mb-4" *ngFor="let skill of formattedSkills; let index = index;">
                            <span class="skills-chip mr-2 px-2 py-1 mb-1">{{skill | titlecase}}</span>
                                <span class="f-12 pointer text-webbtree-green" (click)="formatSkills('more')" *ngIf="skillsData.length > 5 && index == 4 && formattedSkills.length == 5">
                                + {{skillsData.length - 5}} more skills
                            </span>
                            <span class="pointer text-webbtree-green" (click)="formatSkills('less')" *ngIf="skillsData.length > 5 && index == skillsData.length - 1">
                                view less
                            </span>
                        </span>
                    </div>
                </div>
            </div>
            <hr class="mt-0 mb-1" />
        </div>
    </div>
</div>

<!-- Headline -->
<div class="pb-1" *ngIf="basicDetails?.headline">
    <span class="f-14 font-weight-600 d-block mb-2" >
        <i class="fa-light fa-circle-user mr-1"></i>
    Headline
    </span>
    <div class="mb-4">
        <div class=" d-flex align-items-baseline" >
            <div class="w-100 f-12" >
                <span>{{basicDetails?.headline}}</span>
            </div>
        </div>
    </div>
    <hr class="mt-0 mb-1" />
</div>

<div class="pb-1" *ngIf="basicDetails?.summary">
    <span class="f-14 font-weight-600 d-block mb-2" >
        <i class="far fa-file-pen mr-1"></i>
    Summary
    </span>
    <div class="mb-4">
        <div class=" d-flex align-items-baseline" >
            <div class="w-100 f-12" >
                <span>{{basicDetails?.summary}}</span>
            </div>
        </div>
    </div>
    <hr class="mt-0 mb-1" />
</div>

<div>
    <div class="row mb-1">
        <div class="col d-flex justify-content-between">
            <p class="f-14 font-weight-600 mb-0"><i class="fa-regular fa-briefcase f-12 font-weight-normal mr-2"></i> Experience</p>
            <span *ngIf="isCurrentUserTheCreator" class="pointer text-bluex ats-cta-btn"> <i class="fa-regular fa-plus webtree-btn" (click)="handleAction('edit-experience')"></i></span>
        </div>
    </div>
    <div class="" *ngIf="experienceDetails?.length > 0">
        <div class="row mb-3px onHover py-1 position-relative" *ngFor="let experience of experienceDetails">
            <div class="col" *ngIf="experience?.companyname || experience?.jobtitle">
                <div class="d-flex mb-1">
                    <div>
                        <span class="clogo c-pointer" (click)="openUrl(experience?.website, 'website')">
                            <i class="fas fa-building" *ngIf="!experience?.companylogo"></i>
                            <img [src]="experience?.companylogo" class="img-fluid" *ngIf="experience?.companylogo" [alt]="experience?.companyname" />
                        </span>
                    </div>
                    <div class="onHover d-flex justify-content-between w-100" style="position: relative;">
                        <div>
                            <p class="f-14 font-weight-500 mb-1">{{experience?.jobtitle | titlecase}}</p>
                            <p class="f-14 mb-1" (mouseenter)="getCompanyInfo(experience)" [ngClass]="{'companyHover': experience?.website, 'dstooltip pointer':experience?.website}">
                                {{experience?.companyname | titlecase}}

                                <span class="dstooltip-content">
                                    <app-company-hover-modal [companyInformation]="currentCompanyInformation"></app-company-hover-modal>
                                </span>
                            </p>

                            <div class="f-14 mb-1 text-9696 d-flex align-items-center">
                                <span class="text-truncate f-12" style="max-width: 50%;" matTooltip="{{experience?.locationname | titlecase}}" [matTooltipClass]="{ 'red-tooltip': true }">{{experience?.locationname | titlecase}}</span>
                              <i class="fas fa-circle f-10 mx-2" style="font-size: 3px; margin-top: 0px;" *ngIf="experience?.locationname"></i>
                                <span class="f-12 gray-text" *ngIf="experience.iscurrent == 0 && experience?.startdate != 'Invalid date' && experience?.enddate != 'Invalid date'">
                                    {{experience?.startdate | date: 'MMM yyyy'}}
                                    <span *ngIf="experience?.startdate && experience?.enddate">-</span>
                                    {{experience?.enddate | date: 'MMM yyyy'}}
                                    {{experience.totaltenure ? '(' + experience.totaltenure + ')' : '' }}
                                </span>
                                <span class="f-12 gray-text" *ngIf="experience.iscurrent == 1 && experience?.startdate != null"> {{experience?.startdate | date: 'MMM yyyy'}} - Current {{experience.totaltenure ? '(' + experience.totaltenure + ')' : '' }}</span>
                              </div>
                            <p class="f-12" *ngIf="experience?.workdescription?.length">
                                <span *ngIf="experience?.formattedWorkDescription?.data?.length <= 1">
                                    <span>
                                        {{experience?.formattedWorkDescription?.data[0]}}
                                    </span>
                                </span>

                                <span *ngIf="experience?.formattedWorkDescription?.data?.length > 1" class="exp-list">
                                    <ul>
                                        <li *ngFor="let exp of experience?.formattedWorkDescription?.data">
                                            {{exp}}
                                        </li>
                                    </ul>
                                </span>

                                <span class="f-12 pointer text-webbtree-green"
                                    *ngIf="experience?.formattedWorkDescription?.canOverflow && experience?.formattedWorkDescription?.isTruncated"
                                    (click)="formatDescription('view-more', experience)">
                                    view more
                                </span>
                                <span class="f-12 pointer text-webbtree-green"
                                    *ngIf="experience?.formattedWorkDescription?.canOverflow && !experience?.formattedWorkDescription?.isTruncated"
                                    (click)="formatDescription('view-less', experience)">
                                    view less
                                </span>
                            </p>
                        </div>
                        <span class="onhverEdit" *ngIf="isCurrentUserTheCreator" style="position: absolute; right: 0; top: 10px;">
                            <span class="ats-cta-btn"> <i class="fas fa-edit webtree-btn" (click)="handleAction('edit-experience', experience)"></i></span> &nbsp;
                            <span class="ats-cta-btn"><i class="fas fa-trash-alt webtree-btn" (click)="handleAction('delete-experience', experience)"></i></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <hr class="mt-0 mb-3" />
</div>


<div class="row mb-1">
    <div class="col d-flex justify-content-between">
        <p class="f-14 font-weight-600 mb-0"><i class="fa-regular fa-user-graduate f-12 font-weight-normal mr-2"></i> Education</p>
        <span *ngIf="isCurrentUserTheCreator" class="pointer text-bluex ats-cta-btn"><i class="fas fa-plus webtree-btn" (click)="handleAction('edit-education')"></i></span>
    </div>
</div>

<div class="" *ngIf="educationDetails?.length > 0">
    <div class="row mb-3px onHover py-1 position-relative" *ngFor="let education of educationDetails">
      <div class="col">
        <div class="d-flex mb-1 pb-1 border-bottom">
          <div>
          <span class="clogo c-pointer">
            <i class="fas fa-graduation-cap"></i>
            </span>
            </div>
            <div class=" d-flex justify-content-between w-100">
              <div>
                  <p class="f-14 mb-1">{{education?.degree | titlecase}} <span *ngIf="education?.fieldofstudy && education?.degree"></span></p>
                  <p class="text-9696 f-12 mb-1">
                      {{education?.institutename | titlecase}}
                      <i class="fas fa-circle f-10 mx-1" style="font-size: 3px; margin-top: 0px;" aria-hidden="true"></i>
                      <span *ngIf="education?.startdate != 'Invalid date' && education?.enddate != 'Invalid date'">{{education?.startdate}} - {{education?.enddate ? education?.enddate : 'Current'}}</span>
                  </p>
              </div>

              <div>
                  <span class="r0 pointer text-bluex onhverEdit position-absolute mr-3" *ngIf="isCurrentUserTheCreator">
                      <span class="ats-cta-btn"><i class="fas fa-edit webtree-btn" (click)="handleAction('edit-education', education);"></i> </span>&nbsp;
                      <span class="ats-cta-btn"> <i class="fas fa-trash-alt webtree-btn" (click)="handleAction('delete-education', education)"></i></span>
                  </span>
              </div>
          </div>
        </div>

      </div>

    </div>
</div>


<!-- Candidate certificates -->
<div *ngIf="candidateCertification?.length">
    <hr class="mt-0 mb-3"  />
    <div class="row mb-1">
        <div class="col d-flex justify-content-between">
            <p class="f-14 font-weight-600 mb-0">
                <i class=" far fa-file-certificate f-12 font-weight-normal mr-2"></i> Certification
            </p>
        </div>
    </div>

    <div class="" *ngIf="candidateCertification?.length > 0">
        <div class="row mb-3px onHover py-1 position-relative" *ngFor="let cert of candidateCertification">
            <div class="col">
                <div class="d-flex mb-1 pb-1 border-bottom">
                    <div>
                        <span class="clogo c-pointer">
                            <i class="fa-duotone fa-solid fa-certificate"></i>
                        </span>
                    </div>
                    <div class=" d-flex justify-content-between w-100">
                        <div>
                            <p class="f-14 mb-1">{{cert?.name | titlecase}} <span *ngIf="cert?.name"></span></p>
                            <p class="text-9696 f-12 mb-1">
                                {{cert?.organization | titlecase}}
                                <i class="fas fa-circle f-10 mx-1" style="font-size: 3px; margin-top: 0px;"
                                    aria-hidden="true"></i>
                                <span
                                    *ngIf="cert?.startdate != 'Invalid date' && cert?.enddate != 'Invalid date'">{{cert?.startdate}}
                                    - {{cert?.enddate ? cert?.enddate : 'Current'}}</span>
                            </p>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<hr class="mt-0 mb-3" />

<div class="mb-2" *ngIf="interestDetails && interestDetails.length">
    <span class="f-14 font-weight-600 mb-3 d-block">
        <i class="far fa-pencil-paintbrush mr-1"></i>
        Interest
    </span>
    <div>
        <span *ngFor="let interest of interestDetails" class="interest mr-2 px-2 py-1 mb-1 mr-0">
            {{interest}}
        </span>
    </div>
    <hr class="mt-0 mb-3" />
</div>



<div *ngIf="experienceDetails?.length == 0 && educationDetails?.length == 0 && basicDetails?.pdldetailsextracted == 1">
    <div class="row mb-3">
        <div class="col d-flex justify-content-between">
            <span class="f-16">Experience & Education</span>
        </div>
    </div>
    <div class="row mb-2">
        <div class="col">
            <div class="addDocuments">
                <p class="text-blue font-weight-600 pointer">
                    <a data-testid="auto-app-profile-tab-a-1" class="text-webbtree-green f-14" (click)="redirecttolinkedin()">Extract this information via Chrome Extension</a>
                </p>
            </div>
        </div>
    </div>
</div>
